import React from 'react';
import SelectPill from '../SelectPill/SelectPill';
import ValidationErrorLabel from '../../../common/ValidationErrorLabel/ValidationErrorLabel';
import styles from './PreferenceTypeTwo.module.scss';

export function PreferenceTypeTwo({ fields, state, setState, disabled, errorMsg }) {
  fields.forEach((item) => {
    item.selected = state[item.option];
  });

  return (
    <div>
      {!disabled && !fields.filter((item) => item.selected).length && <ValidationErrorLabel message={errorMsg} />}
      <form className={`form-check ${styles.inputForm}`}>
        {fields?.map((x) => {
          const { label, id, selected, option } = x;
          return (
            <SelectPill
              onChange={(e) => setState((y) => ({ ...y, [option]: e.target.checked }))}
              key={id}
              id={`${label}-${id}${disabled}`}
              label={label}
              selected={selected}
              disabled={disabled}
            />
          );
        })}
      </form>
    </div>
  );
}
